export default class Container {
    constructor() {

        this.id = 0
        this.containerType = '';
        this.teu = '';
        this.containerNumber = '';
        this.sealNumber = '';
    }
}
